'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

var radioConstants = {
  backgroundColorDefault: _reactackleCore.colorTransparent,
  backgroundColorChecked: _reactackleCore.colorSecondary,
  labelColorDefault: _reactackleCore.bodyFontColor,
  labelColorDisabled: _reactackleCore.colorPaletteGrey500
};

exports.default = {
  input: {
    similarItemsSpacing: (0, _reactackleCore.bmodule)(1),
    size: (0, _reactackleCore.bmodule)(2.25),
    borderWidth: 1,
    borderRadius: _reactackleCore.radiusRounded,
    backgroundColor: radioConstants.backgroundColorDefault,
    borderColor: _reactackleCore.colorPaletteGrey400,

    hover: {
      backgroundColor: radioConstants.backgroundColorDefault,
      borderColor: _reactackleCore.colorPaletteGrey600
    },

    focus: {
      backgroundColor: radioConstants.backgroundColorDefault,
      borderColor: _reactackleCore.colorSecondary
    },

    disabled: {
      backgroundColor: _reactackleCore.colorPaletteGrey100,
      borderColor: _reactackleCore.colorPaletteGrey300
    },

    checked: {
      backgroundColor: radioConstants.backgroundColorChecked,
      borderColor: _reactackleCore.colorSecondary,
      knobOffsetSize: 3,
      knobOffsetColor: _reactackleCore.colorWhite,

      hover: {
        backgroundColor: radioConstants.backgroundColorChecked,
        borderColor: _reactackleCore.colorPaletteGrey500,
        knobOffsetSize: 3,
        knobOffsetColor: _reactackleCore.colorWhite
      },

      focus: {
        backgroundColor: radioConstants.backgroundColorChecked,
        borderColor: _reactackleCore.colorSecondary,
        knobOffsetSize: 3,
        knobOffsetColor: _reactackleCore.colorWhite
      },

      disabled: {
        backgroundColor: _reactackleCore.colorPaletteGrey200,
        borderColor: _reactackleCore.colorPaletteGrey300,
        knobOffsetSize: 3,
        knobOffsetColor: _reactackleCore.colorWhite
      }
    }
  },

  label: {
    inputLabelSpacing: (0, _reactackleCore.bmodule)(1),
    fontSize: function fontSize(_ref) {
      var _fontSize = _ref.fontSize;
      return _fontSize[0];
    },
    lineHeight: 1.5,
    fontColor: radioConstants.labelColorDefault,

    hover: {
      fontColor: radioConstants.labelColorDefault
    },

    focus: {
      fontColor: radioConstants.labelColorDefault
    },

    disabled: {
      fontColor: radioConstants.labelColorDisabled
    },

    checked: {
      fontColor: radioConstants.labelColorDefault,

      hover: {
        fontColor: radioConstants.labelColorDefault
      },

      focus: {
        fontColor: radioConstants.labelColorDefault
      },

      disabled: {
        fontColor: radioConstants.labelColorDisabled
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-radio-group/dist/styles/theme.js
// module id = 781
// module chunks = 0